import React from "react";
import { useParams } from "react-router-dom";
import ObjectJobs from "../components/ObjectJobs";


const Jobs: React.FC = () => {
  const { projectId } = useParams();
  return <ObjectJobs projectId={projectId} showToolbarBtn={false} />;
}

export default Jobs;